export const appName = "Father’s Coffee Roastery";
